export default {
  title: 'Rechnungen',
  form: {
    auto_generate_invoices: {
      label: 'Rechnungen automatisch erstellen',
    },
  },
  buttons: {
    save: 'Speichern',
  },
  toasts: {
    failed_to_save_changes: 'Änderungen konnten nicht gespeichert werden',
    changes_got_saved: 'Änderungen wurden gespeichert',
  },
};
